<template>
  <custom-dialog class="isp-task-detail-dialog" :title="$t('dms_task_detail_dialog.ren_wu_nei_rong')" width="1000px" :visible="visible" v-on="$listeners"
    :append-to-body="true">
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table height="100%" :data="tableList" tableCode="isp_task_details" :index="true"></custom-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
  },
  data() {
    return {
      tableList: [],
    };
  },
  methods: {
    init() {
      const reqData = {
        simTaskId: this.model.data.simTaskId,
      };
      this.$getJSON(apis.simIspTaskDetail, reqData).then((res) => {
        this.tableList = Array.isArray(res.data) ? res.data : res.data.list;
      });
    },
    closeDialog() {
      this.visible = false;
    }
  },
  created() { },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.isp-task-detail-dialog {
  .table-bd {
    height: 500px;
  }
}
</style>
